exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BannerSwiperContainer_Jjy9rBnH {\n    width: 1000px;\n    margin: 0 auto;\n    overflow: hidden;\n}\n\n.listOuter_1VrWpxLw {\n    margin: 34px 0;\n}\n\n.list_31XeZ-Sb img {\n    display: block;\n    margin: 0 auto;\n}\n", ""]);

// exports
exports.locals = {
	"BannerSwiperContainer": "BannerSwiperContainer_Jjy9rBnH",
	"listOuter": "listOuter_1VrWpxLw",
	"list": "list_31XeZ-Sb"
};